module.exports = __webpack_public_path__ + "static/media/Popular-red.56c05549.svg";